<script setup>
defineProps({
  label: String,
})
defineEmits(['click'])
</script>
<template>
  <button class="btn btn-primary" type="button" @click.prevent.self="$emit('click')">
    {{ label }}
  </button>
</template>
